







import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";

import IdleTimer from "./IdleTimer";
import IdlePage from "./IdlePage.vue";

interface AuthModule {
  isLoggedIn: true;
  isLoggedOut: true;
}

/**
 * Use this component to redirect the user after an idle period.
 *
 * If the user is not logged in or the time out is not yet reached, the
 * default slot is loaded. Once the redirect has occured, an idle page is
 * shown. You can override it by filling the `idle-page` slot.
 * The default idle page uses the `RTitle` and `RButton` components.
 */
@Component({
  components: {
    IdlePage
  }
})
export default class IdleRedirect extends Vue {
  @Inject() authStore!: AuthModule;

  @Prop({
    type: String,
    default:
      window.location.protocol +
      "//" +
      window.location.host +
      process.env.BASE_URL +
      "ausgeloggt-wegen-inaktivitaet"
  })
  redirectTarget!: string;
  @Prop({
    type: Number,
    default: Number(process.env.VUE_APP_RAS_IDLE_TIME_LIMIT)
  })
  timeLimit!: number;

  idleTimer!: IdleTimer;

  get location() {
    return window.location.href;
  }

  get isLoggedIn() {
    return this.authStore.isLoggedIn;
  }
  get isLoggedOut() {
    return this.authStore.isLoggedOut;
  }

  @Watch("isLoggedIn")
  onLogin(isLoggedIn: boolean) {
    if (isLoggedIn) {
      this.idleTimer.start();
    }
  }

  @Watch("isLoggedOut")
  onLogout(isLoggedOut: boolean) {
    if (isLoggedOut) {
      this.idleTimer.stop();
    }
  }

  created() {
    this.idleTimer = new IdleTimer();
    this.idleTimer.setCallback(() => {
      window.location.href = this.redirectTarget;
      return false;
    }, this.timeLimit);
  }
}
